import * as types from './mutations_types';

const mutations = {
  [types.MY_WEBSOCKET](state, myWebSocket) {
    state.myWebSocket = myWebSocket;
  },
  [types.TIMER_MYWEBSOCKET_TIMEOUT](state, timerMyWebSocketTimeOut) {
    state.timerMyWebSocketTimeOut = timerMyWebSocketTimeOut;
  },
  [types.TIMER_MYWEBSOCKET_HEART](state, timerMyWebSocketHeart) {
    state.timerMyWebSocketHeart = timerMyWebSocketHeart;
  },
  [types.ISSUE_LIST](state, issueList) {
    state.issueList = issueList;
  },
  [types.TIMER_MYWEBSOCKET_TIMEINTER](state, timerMyWebSocketTimeInter) {
    state.timerMyWebSocketTimeInter = timerMyWebSocketTimeInter;
  },
};

export default mutations;
